import React from 'react';
export var Padding = function Padding(_ref) {
  var _ref$Tag = _ref.Tag,
    Tag = _ref$Tag === void 0 ? 'div' : _ref$Tag,
    bottom = _ref.bottom,
    children = _ref.children,
    horizontal = _ref.horizontal,
    left = _ref.left,
    right = _ref.right,
    top = _ref.top,
    vertical = _ref.vertical;
  return /*#__PURE__*/React.createElement(Tag, {
    style: {
      paddingBottom: vertical || bottom,
      paddingLeft: horizontal || left,
      paddingRight: horizontal || right,
      paddingTop: vertical || top
    },
    "data-t-id": "components-Padding"
  }, children);
};